import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const HelpAndSupportPage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.HelpAndSupport,
  }))
);

export function HelpAndSupportContainer() {
  return <LazyLoadComponent Component={<HelpAndSupportPage />} />;
}
